import request from '../utils/http'
// 校区信息
export function index (query) {
  return request({
    url: '/campus/list',
    method: 'GET',
    params: query
  })
}
// 新增校区
export function save (query) {
  return request({
    url: '/campus/save',
    method: 'POST',
    data: query
  })
}
// 编辑校区
export function edit (query) {
  return request({
    url: '/campus/edit',
    method: 'GET',
    params: query
  })
}
// 更新校区
export function update (query) {
  return request({
    url: '/campus/update',
    method: 'POST',
    data: query
  })
}
// 删除校区
export function del (query) {
  return request({
    url: '/campus/delete',
    method: 'DELETE',
    data: query
  })
}
// 机构信息
export function mechanism (query) {
  return request({
    url: '/mechanism/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 导出校区数据
export function campusExport (query) {
  return request({
    url: '/campus/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/campus.js